import { useMemo, useState } from 'react';
import LangContext from './LangContext';
import useFetchQuery from '../hooks/useFetchQuery';
import createFetchCache from '../helpers/createFetchCache';

const langCache = createFetchCache('LANG_LIST', {
    duration: 24,
    unit: 'hours',
});

function LangContextProvider({ children }) {
    const { enabled, get, set } = langCache();
    const [dictionary, setDictionary] = useState({});
    const [userLang, setUserLang] = useState('en');

    const { data = get().data || [] } = useFetchQuery({
        url: '/language-codes',
        enabled: () => enabled(),
        method: 'get',
        onFetchSuccess: ({ data }) => {
            set(data?.language_codes || []);
            return data?.language_codes || [];
        },
    });

    const contextValue = useMemo(
        () => ({
            dictionary,
            userLang,
            setUserLang,
            listLang: data,
            setDictionary,
        }),
        [dictionary, userLang, data, setUserLang, setDictionary]
    );

    return <LangContext.Provider value={contextValue}>{children}</LangContext.Provider>;
}

export default LangContextProvider;
